import { put, takeEvery, all } from 'redux-saga/effects';

import * as logger from '../utils/logger';
import getBaseUrl from '../utils/base-url';

import actionsLogger from './actions-logger';

import { tags, categories } from '../utils/variables';

// import { DESIGNS_CATEGORIES_LOAD_RESPONSE } from './designs-categories';

export const REQUEST_DESIGNS_LIST_LOAD =
  'designs-list/REQUEST_DESIGNS_LIST_LOAD';
export const DESIGNS_LIST_LOAD_RESPONSE =
  'designs-list/DESIGNS_LIST_LOAD_RESPONSE';
export const DESIGNS_LIST_LOAD_FAIL = 'designs-list/DESIGNS_LIST_LOAD_FAIL';

export const LOAD_SHARED_DESIGNS_REQUEST =
  'designs-list/LOAD_SHARED_DESIGNS_REQUEST';
export const LOAD_SHARED_DESIGNS_RESPONSE =
  'designs-list/LOAD_SHARED_DESIGNS_RESPONSE';
export const LOAD_SHARED_DESIGNS_FAIL = 'designs-list/LOAD_SHARED_DESIGNS_FAIL';

export const REQUEST_DESIGNS_REMOVE = 'designs-list/REQUEST_DESIGNS_REMOVE';

export const actionCreators = {
  loadSharedDesigns: (categoryId, page) => ({
    type: LOAD_SHARED_DESIGNS_REQUEST,
    payload: { categoryId, page }
  }),
  requestDesignRemove: id => ({ type: REQUEST_DESIGNS_REMOVE, payload: { id } })
};

function* loadSharedDesigns(action) {
  try {
    const { categoryId } = action.payload;

    if (action.payload.page > 20) {
      logger.error(new Error('Why we are loading so many pages?!?'));
    }

    const urlParams = `?page[size]=50&page[number]=${
      action.payload.page
    }&sort=-shared_at`;

    let filter =
      categoryId === 'all'
        ? '&filter[category]=' + categories.join('|')
        : '&filter[category]=' + categoryId;

    if (tags.length) {
      filter += '&filter[tag_list]=' + tags.join(',');
    }

    const url = getBaseUrl() + '/designs/shared' + urlParams + filter;
    const res = yield fetch(url, {
      method: 'GET',
      credentials: 'same-origin'
    });

    if (res.status !== 200) {
      yield put({
        type: LOAD_SHARED_DESIGNS_FAIL
      });
      const text = yield res.text();
      logger.error(new Error('Can not load shared designs: ' + text));
      return;
    }
    const json = yield res.json();

    yield put(actionsLogger.logRequest(json));

    yield put({
      type: LOAD_SHARED_DESIGNS_RESPONSE,
      payload: {
        items: json.data,
        categoryId,
        pushItems: action.payload.page > 1,
        hasMore: action.payload.page < json.meta.page.total_pages
      }
    });
  } catch (e) {
    yield put({
      type: LOAD_SHARED_DESIGNS_FAIL
    });
    logger.error(e);
  }
}

export default function* designsListSaga() {
  yield all([takeEvery(LOAD_SHARED_DESIGNS_REQUEST, loadSharedDesigns)]);
}



// WEBPACK FOOTER //
// ./src/actions/designs-list.js